import styled from 'styled-components'
import Text from 'components/shared/Text'

interface StyledHighlightedTextProps {
    hasFullLineTexts?: boolean
}

export const StyledHighlightedText = styled(Text)<StyledHighlightedTextProps>`
    display: ${({ hasFullLineTexts }) =>
        hasFullLineTexts ? 'block' : 'inline'};
`
